import { Injectable } from '@angular/core';
import * as constants from '../constants-types/constants';
import { JobMatchValue } from '../constants-types/Enums';
import {
    JobPipelineHealth,
    JobPipelineHealthCounts
} from '../core-data-model/Job/JobPipelineHealth.model';

// Have to alias these so Prettify doesn't break all the casting below.
// The solution here is probably to refactor this to not handle 3 types
import {
    JobAssociatedPersonServer as JobAssocPerson,
    ActiveJobsCardDataServerEntryPerson as AJCServerPerson
} from '../core-data-model/JobApi.serverinterface';
import { AssociatedPersonInformationServer as AssocPerson } from '../core-data-model/JobInformation.interface';

@Injectable({
    providedIn: 'root'
})
export class JobPipelineTransformers {
    transformPipelineHealth(
        jobId: string,
        associatedPeople: (AssocPerson | JobAssocPerson | AJCServerPerson)[]
    ): JobPipelineHealth {
        const applicantIds = associatedPeople.map((person) => {
            if ((<JobAssocPerson>person).person) {
                return (<JobAssocPerson>person).person.assessmentUser
                    .assessmentUserId;
            } else if ((<AssocPerson>person).personId) {
                return (<AssocPerson>person).personId;
            } else {
                return (<AJCServerPerson>person).id;
            }
        });
        const totalCandidates = associatedPeople.length;
        const healthCounts = associatedPeople.reduce(
            (totals, person) => {
                const normalPerson = <AssocPerson | JobAssocPerson>person;
                const activeJobsCardPerson = <AJCServerPerson>person;
                const combinedFitScore =
                    activeJobsCardPerson.overallFitScore ||
                    normalPerson.combinedFitScore;
                if (combinedFitScore === null) {
                    totals[JobMatchValue.Pending]++;
                } else if (
                    combinedFitScore >=
                    constants.jobMatchCutoff[JobMatchValue.Great]
                ) {
                    totals[JobMatchValue.Great]++;
                } else if (
                    combinedFitScore >=
                    constants.jobMatchCutoff[JobMatchValue.Ok]
                ) {
                    totals[JobMatchValue.Ok]++;
                } else if (
                    combinedFitScore >=
                    constants.jobMatchCutoff[JobMatchValue.Low]
                ) {
                    totals[JobMatchValue.Low]++;
                }
                return totals;
            },
            {
                [JobMatchValue.Great]: 0,
                [JobMatchValue.Ok]: 0,
                [JobMatchValue.Low]: 0,
                [JobMatchValue.Pending]: 0
            } as JobPipelineHealthCounts
        );
        return {
            applicantIds,
            jobId,
            healthCounts,
            totalCandidates
        };
    }
}
